import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur mycket alkohol får jag sälja per besökare vid gårdsförsäljning?";
const SHORT_ANSWER = "Förslaget innebär begränsningar per besökare och dag, t.ex. 1 liter sprit, 3 liter vin eller 6 liter starköl. Exakta tak slås fast i föreskrifter.";

export const Route = createFileRoute("/fraga/hur-mycket-far-jag-salja-per-besokare")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur mycket alkohol får jag sälja per besökare v…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Volymerna är jämförelsevis låga och tänkta att förhindra storinköp som konkurrerar med Systembolaget. Försäljning över taken kräver Systembolagets distributionsmodell."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning/regler-2026", label: "Volymregler för gårdsförsäljning" }}
      related={[{"to": "/fraga/behover-jag-egen-tillverkning", "label": "Måste jag tillverka själv för att få gårdsförsäljning?"}, {"to": "/fraga/far-vingard-salja-via-natet", "label": "Får en vingård sälja vin via nätet under gårdsförsäljningsreglerna?"}, {"to": "/fraga/vem-far-salja-pa-gardsforsaljning", "label": "Vem får sälja alkohol via gårdsförsäljning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur mycket alkohol får jag sälja per besökare vid gårdsfö…" },
      { name: "description", content: "Förslaget innebär begränsningar per besökare och dag, t.ex. 1 liter sprit, 3 liter vin eller 6 liter starköl. Exakta tak slås fast i föreskrifter." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-mycket-far-jag-salja-per-besokare" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-mycket-far-jag-salja-per-besokare" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-mycket-far-jag-salja-per-besokare",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur mycket alkohol får jag sälja per besökare v…", url: "https://alkoholprovet.se/fraga/hur-mycket-far-jag-salja-per-besokare" },
      ]),
    ],
  }),
});
